import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import OptionalSubjectModal from "./OptionalSubjectModal/OptionalSubjectModal"
import { useAuthState } from "../../../../helper/Context/context"
import { GET_WEB_DB_T_ExaminationFormMainCount_SelectAPI } from "../../../../helper/Redux/Slices/DashboardSlice/DashboardSlice"
import { LogoLoader } from "../../../../helper/Loaders/LogoLoader"

export const MainContain = () => {
    const Navigate = useNavigate()

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth } = userDetails
    const { UserID, token } = userDetails.user

    const [LicentiateCountdata, setLicentiateCountdata] = useState([])
    const [AssociateCountdata, setAssociateCountdata] = useState([])
    const [FellowCountdata, setFellowCountdata] = useState([])
    const [SpecialisedData, setSpecialisedData] = useState([])

    const [isLoading, setisLoading] = useState(false)
    const [showOptional, setshowOptional] = useState({
        data: '',
        modalname: '',
        show: false
    })

    useEffect(() => {
        handleGetCount()
    }, [year.Label, Month.ID])

    const handleGetCount = () => {
        setisLoading(true)
        const data = {
            M_FinancialYearID: year.Label != "Year ....." ? year.Label : '0',
            M_MonthID: Month.ID,
            T_ExaminationFormID: '0',
            M_MainSubjectID: '0',
            M_SubSubjectID: '0',
            OptionalSub_M_IndicatorID: '0',
            Flag: 'MainCount',
            M_UserID: UserID,
            token: token,
            setisLoading: setisLoading,
            handleSetLicentiateCount: handleSetLicentiateCount,
            handleSetAssociateCount: handleSetAssociateCount,
            handleSetFellowCount: handleSetFellowCount,
            handlesetSpecialisedData: handlesetSpecialisedData
        }
        GET_WEB_DB_T_ExaminationFormMainCount_SelectAPI({ data })
    }

    const handleSetLicentiateCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setLicentiateCountdata(data)
    }

    const handleSetAssociateCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setAssociateCountdata(data)
    }

    const handleSetFellowCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setFellowCountdata(data)
    }

    const handlesetSpecialisedData = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setSpecialisedData(data)
    }

    const handleShowOptional = (value, name) => {
        setshowOptional({
            data: value,
            modalname: name,
            show: true
        })
    }
    const handleCloseOptional = () => {
        setshowOptional({
            data: '',
            modalname: '',
            show: false
        })
    }
    return (
        <>
            {isLoading && <LogoLoader />}

            <div className="row px-0 me-0 mt-5 mt-lg-0 Licentiate_Certificate bg_gray_card">

                <h5 className="fw-bold pt-3 ps-4 pb-3 mb-4 border-bottoms2">Insurance Institute of India Examinations </h5>


                <div className="col-12 col-lg-6 px-4 pb-4 ">
                    <div className="border_card bg-white">
                        <h6 className="fw-bold fs-6 pb-2 ps-4 border-bottoms heading_dashboard  pt-3 pb-3">Licentiate Certificate</h6>

                        <div className="row pt-2 p-4  m-0">
                            {
                                LicentiateCountdata && LicentiateCountdata?.length > 0 ? LicentiateCountdata.map((L) => {
                                    return (
                                        <>
                                            <div className="col-10">
                                                <p>{L?.paramName}</p>
                                            </div>
                                            <div className="col-2">
                                                <h5 className={L?.totalCount > 0 ? "cursor-pointer" : ""}
                                                    onClick={() => {
                                                        L?.paramName == "Optional Subject" ?
                                                            handleShowOptional(L, 'Licentiate Certificate')
                                                            :
                                                            L?.totalCount > 0 ?
                                                                Navigate(`/LicentiateCertificate?paramName=${'Licentiate Certificate' + ' - ' + L?.paramName}&m_MainSubjectID=${L?.m_MainSubjectID}&m_SubSubjectID=${L?.m_SubSubjectID}&optionalSub_M_IndicatorID=${L?.optionalSub_M_IndicatorID}`)
                                                                : console.log('')
                                                    }}>
                                                    {L?.totalCount}
                                                </h5>
                                            </div>
                                        </>
                                    )
                                })
                                    :
                                    <div className="text-center col-12">
                                        <text>No Record Found ...</text>
                                    </div>
                            }

                        </div>

                    </div>
                </div>

                <div className="col-12 col-lg-6 px-4 pb-4 ">
                    <div className="border_card bg-white">
                        <h6 className="fw-bold fs-6 pb-2 ps-4 border-bottoms heading_dashboard2  pt-3 pb-3">Associateship Diploma </h6>

                        <div className="row pt-2 p-4  m-0">
                            {
                                AssociateCountdata && AssociateCountdata?.length > 0 ? AssociateCountdata.map((A) => {
                                    return (
                                        <>
                                            <div className="col-10">
                                                <p>{A?.paramName}</p>
                                            </div>
                                            <div className="col-2">
                                                <h5 className={A?.totalCount > 0 ? "cursor-pointer" : ""}
                                                    onClick={() => {
                                                        A?.paramName == "Optional Subject" ?
                                                            handleShowOptional(A, 'Associateship Diploma')
                                                            :
                                                            A?.totalCount > 0 ?
                                                                Navigate(`/LicentiateCertificate?paramName=${'Associateship Diploma' + ' - ' + A?.paramName}&m_MainSubjectID=${A?.m_MainSubjectID}&m_SubSubjectID=${A?.m_SubSubjectID}&optionalSub_M_IndicatorID=${A?.optionalSub_M_IndicatorID}`)
                                                                : console.log('')
                                                    }}>
                                                    {A?.totalCount}</h5>
                                            </div>
                                        </>
                                    )
                                })
                                    :
                                    <div className="text-center col-12">
                                        <text>No Record Found ...</text>
                                    </div>
                            }
                        </div>

                    </div>
                </div>

                <div className="col-12 col-lg-6 px-4 pb-4">
                    <div className="border_card bg-white">
                        <h6 className="fw-bold fs-6 pb-2 ps-4 border-bottoms heading_dashboard2  pt-3 pb-3">Fellowship Diploma </h6>

                        <div className="row pt-2 p-4  m-0">
                            {
                                FellowCountdata && FellowCountdata?.length > 0 ? FellowCountdata.map((F) => {
                                    return (
                                        <>
                                            <div className="col-10">
                                                <p>{F?.paramName}</p>
                                            </div>
                                            <div className="col-2">
                                                <h5 className={F?.totalCount > 0 ? "cursor-pointer" : ""}
                                                    onClick={() => {
                                                        F?.paramName == "Optional Subject" ?
                                                            handleShowOptional(F, 'Fellowship Diploma')
                                                            :
                                                            F?.totalCount > 0 ?
                                                                Navigate(`/LicentiateCertificate?paramName=${'Fellowship Diploma' + ' - ' + F?.paramName}&m_MainSubjectID=${F?.m_MainSubjectID}&m_SubSubjectID=${F?.m_SubSubjectID}&optionalSub_M_IndicatorID=${F?.optionalSub_M_IndicatorID}`)
                                                                : console.log('')
                                                    }}>
                                                    {F?.totalCount}</h5>


                                            </div>
                                        </>
                                    )
                                })
                                    :
                                    <div className="text-center col-12">
                                        <text>No Record Found ...</text>
                                    </div>
                            }

                        </div>

                    </div>
                </div>


                <div className="col-12 col-lg-6 px-4 pb-4 ">
                    <div className="border_card bg-white">
                        <h6 className="fw-bold fs-6 pb-2 ps-4 border-bottoms heading_dashboard pt-3 pb-3">Specialised Diploma on Marine Insurance</h6>

                        <div className="row pt-2 p-4  m-0">
                            {
                                SpecialisedData && SpecialisedData?.length > 0 ? SpecialisedData.map((A) => {
                                    return (
                                        <>
                                            <div className="col-10">
                                                <p>{A?.paramName}</p>
                                            </div>
                                            <div className="col-2">
                                                <h5 className={A?.totalCount > 0 ? "cursor-pointer" : ""}
                                                    onClick={() => {
                                                        A?.paramName == "Optional Subject" ?
                                                            handleShowOptional(A, 'Specialised Diploma on Marine Insurance')
                                                            :
                                                            A?.totalCount > 0 ?
                                                                Navigate(`/LicentiateCertificate?paramName=${'Specialised Diploma on Marine Insurance' + ' - ' + A?.paramName}&m_MainSubjectID=${A?.m_MainSubjectID}&m_SubSubjectID=${A?.m_SubSubjectID}&optionalSub_M_IndicatorID=${A?.optionalSub_M_IndicatorID}`)
                                                                : console.log('')
                                                    }}>
                                                    {A?.totalCount}</h5>
                                            </div>
                                        </>
                                    )
                                })
                                    :
                                    <div className="text-center col-12">
                                        <text>No Record Found ...</text>
                                    </div>
                            }
                        </div>

                    </div>
                </div>

            </div>

            {
                showOptional.show &&
                <OptionalSubjectModal
                    showOptional={showOptional?.data}
                    ModalName={showOptional?.modalname}
                    handleCloseOptional={handleCloseOptional}
                />
            }
        </>
    )
}